import React, { ReactNode } from 'react'

import { Typography } from '@/components/ui/typography'

import * as S from './empty-state.styled'

export interface EmptyStateProps {
  title?: string
  description?: string
  image?: {
    src: string
    alt: string
    width: string
  }
  actions?: ReactNode
}

export const EmptyState = ({
  title = 'No results found',
  description,
  image = {
    alt: 'No results',
    src: '/images/no-results.svg',
    width: '8rem',
  },
  actions,
}: EmptyStateProps) => {
  return (
    <S.Container>
      <S.Image src={image.src} alt={image.alt} $width={image.width} />
      <S.Content>
        <Typography as="h3" size="heading-medium" color="black800">
          {title}
        </Typography>
        {description && (
          <Typography size="text-large" color="black500">
            {description}
          </Typography>
        )}
      </S.Content>
      {actions && <S.Actions>{actions}</S.Actions>}
    </S.Container>
  )
}
